import { addToGlobalThisRet } from "@plugins";

function initTagsActiveControl() {
    const tagsNeedActive = document.querySelector(".js-tags-active-control");

    if (tagsNeedActive) {
        const arr = Array.from(tagsNeedActive.children);

        arr.forEach((tag) => {
            tag.addEventListener("click", () => {
                if (!tag.classList.contains("active")) {
                    tag.classList.add("active");

                    const deactivateBtn = document.createElement("i");

                    deactivateBtn.classList.add("tags-list__deactivate-btn");
                    tag.appendChild(deactivateBtn);

                    deactivateBtn.addEventListener("click", (e) => {
                        e.stopPropagation();
                        deactivateBtn.remove();
                        tag.classList.remove("active");
                    });
                }
            });
        });
    }
}

function initTagsHeightControl() {
    const tagsNeedHeightControl = document.querySelector(".js-tags-height-control");

    if (tagsNeedHeightControl) {
        const callback = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (tagsNeedHeightControl.offsetHeight > 56) {
                        tagsNeedHeightControl.classList.add("collapsed");

                        const showAllTagsBtn = document.createElement("div");
                        const parentWrap = tagsNeedHeightControl.parentNode;

                        showAllTagsBtn.classList.add("tags-list__show-all-tags-btn");
                        showAllTagsBtn.innerHTML = "Показать ещё";
                        parentWrap.appendChild(showAllTagsBtn);

                        showAllTagsBtn.addEventListener("click", () => {
                            if (tagsNeedHeightControl.classList.contains("collapsed")) {
                                tagsNeedHeightControl.classList.remove("collapsed");
                                showAllTagsBtn.innerHTML = "Свернуть";
                            } else {
                                tagsNeedHeightControl.classList.add("collapsed");
                                showAllTagsBtn.innerHTML = "Показать ещё";
                            }
                        });
                    }
                    observer.unobserve(entry.target);
                }
            });
        };

        const observer = new IntersectionObserver(callback, { threshold: 1.0 });

        observer.observe(tagsNeedHeightControl);
    }
}

window.addEventListener("load", () => {
    initTagsActiveControl();
    initTagsHeightControl();
});

addToGlobalThisRet(initTagsActiveControl, "initTagsActiveControl");
addToGlobalThisRet(initTagsHeightControl, "initTagsHeightControl");
